declare namespace $ {

	export class $mol_icon_gesture extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=gesture.view.tree.d.ts.map